import { Link } from "react-router-dom";
import { Leaf, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-forest text-white/85 mt-20 grain overflow-hidden" data-testid="site-footer">
      <div className="container-x mx-auto max-w-7xl py-16 md:py-20 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-white/10 text-white">
              <Leaf size={18} strokeWidth={2.2} />
            </span>
            <span className="font-heading text-lg font-semibold text-white">Be Green Group</span>
          </div>
          <p className="text-white/70 leading-relaxed max-w-sm text-[15px]">
            Cleaner business energy, without the upfront cost. We install, own and maintain
            commercial solar and battery systems — your business only pays for the energy used.
          </p>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-4">Product</p>
          <ul className="space-y-3 text-[14.5px]">
            <li><Link className="hover:text-bright transition-colors" to="/how-it-works">How it works</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/business-energy-plan">Business Energy Plan</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/industries">Industries</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/faq">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-4">Company</p>
          <ul className="space-y-3 text-[14.5px]">
            <li><Link className="hover:text-bright transition-colors" to="/about">About</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/contact">Contact</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/apply">Apply</Link></li>
            <li><Link className="hover:text-bright transition-colors" to="/admin/login">Admin</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-white text-sm font-semibold mb-4">Get in touch</p>
          <ul className="space-y-3 text-[14.5px]">
            <li className="flex items-center gap-2"><Mail size={14} /> hello@begreengroup.com.au</li>
            <li className="flex items-center gap-2"><Phone size={14} /> 1300 000 000</li>
          </ul>
          <p className="mt-6 text-xs text-white/50 leading-relaxed">
            Be Green Group Pty Ltd<br/>Australia
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x mx-auto max-w-7xl py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/60">
          <p>© {new Date().getFullYear()} Be Green Group. Cleaner business energy, without the upfront cost.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Use</Link>
            <Link to="/ppa-disclaimer" className="hover:text-white">PPA Disclaimer</Link>
          </div>
        </div>
        <div className="container-x mx-auto max-w-7xl pb-8 text-[11.5px] text-white/50 leading-relaxed">
          Information provided by Be Green Group is general and indicative only. Eligibility,
          pricing, savings and system suitability are subject to business energy usage, site
          conditions, credit approval, network requirements, funding approval and final contract
          terms.
        </div>
      </div>
    </footer>
  );
}
